import { ChangeEvent, useState } from "react";
import MudrexIcon from "../ui/MudrexIcon/MudrexIcon";

interface Props {
  document: any;
  setUploadedDocuments: React.Dispatch<React.SetStateAction<any[]>>;
  setIsEdited: React.Dispatch<React.SetStateAction<boolean>>;
  uploadedDocuments: any[];
}

const AttachFiles: React.FC<Props> = ({
  document,
  setUploadedDocuments,
  setIsEdited,
  uploadedDocuments,
}) => {
  const {
    cta_text: ctaText,
    document_name: documentName,
    optional,
    status,
    tag,
    comment,
  } = document ?? {};

  const convertToBase64 = (file: File | undefined): Promise<string> => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      if (file) {
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result as string);
        reader.onerror = (error) => reject(error);
      }
    });
  };

  const removeFile = (encodedString: string) => {
    setUploadedDocuments((prev) =>
      prev.filter((file) => file.encoded_string !== encodedString)
    );
    const uploadFileElement = window.document.getElementById("upload-file");
    if (uploadFileElement) {
      (uploadFileElement as HTMLInputElement).value = "";
    }
  };

  const handleFileUpload = async (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setIsEdited(true);
    const files = event.target.files;
    const uploadedFiles = await Promise.all(
      Array.from(files ?? [])?.map(async (file: any) => {
        const base64 = await convertToBase64(file);
        return { document_tag: tag, encoded_string: base64, name: file?.name };
      })
    );
    setUploadedDocuments((prev) => [...prev, ...uploadedFiles]);
  };

  return (
    status !== "COMPLETED" && (
      <div className="mb-4">
        <label className="text-14-sb block mb-2">
          {documentName}{" "}
          {!optional && <span className="text-status-negative">*</span>}
        </label>
        <div>
          {status === "PENDING"
            ? !uploadedDocuments?.some(
                ({ document_tag }) => document_tag === tag
              ) && (
                <p className="text-12-sb text-status-negative mb-2">
                  {comment}
                </p>
              )
            : null}
          <div>
            <div className="flex items-center justify-center border border-dashed border-grad-brand-medium-border rounded-lg p-3 cursor-pointer relative">
              <label className="text-grad-brand-dark-text font-medium text-sm cursor-pointer mr-1">
                {ctaText}
              </label>
              <MudrexIcon icon="Paperclip" size={16} color="#6424C5" />
              <input
                type="file"
                id="upload-file"
                className="absolute inset-0 opacity-0 cursor-pointer"
                accept=".pdf,.jpeg,.jpg,.png"
                onChange={(e) => handleFileUpload(e)}
                multiple
              />
            </div>
            <p className="footnote-10-r mt-[10px] text-grey-medium">
              Supported Format: PDFs, JPEGS and PNGs of max 5MB
            </p>
          </div>
          {uploadedDocuments?.map(
            ({ document_tag, name, encoded_string }) =>
              document_tag === tag && (
                <div className="mt-2">
                  <div className="flex items-center mb-2">
                    <span className="text-grey-medium text-sm truncate">
                      {name}
                    </span>
                    <button
                      className="ml-2 text-status-negative text-sm"
                      onClick={() => removeFile(encoded_string)}
                    >
                      Remove
                    </button>
                  </div>
                </div>
              )
          )}
        </div>
      </div>
    )
  );
};

export default AttachFiles;
